import {ReactComponent as ExitIcon} from './exit.svg'

function Exit() {
  return <ExitIcon />
}

export default Exit
